<template>
  <div>
    <div class="details-component">
      <div class="details-component__header">
        <h1>{{ $t('blacklist.title') }}</h1>
        <div class="details-component__header_right" v-if="$route.params.id">
          <a class="link link--orange" v-on:click="showDeletingConfirmation" v-if="!isDeleted() && (isLandlord() || isCreator())">{{ $t('common.delete') }}&nbsp;
            <i class="icon icon--cross" ></i>
            </a>
        </div>
      </div>
      <div class="details-component__content content">
          <table class="details-table no-col-padding label-r-padding fixed-table label-col-wide-260">
            <tr class="details-table__row">
              <td class="details-table__col details-table__col_label">{{ $t('parking.vehicleReg') }}</td>
              <td class="details-table__col bold">{{ blacklistItem.vehicleReg }}</td>
            </tr>
            <tr class="details-table__row" v-if="isLandlord() && blacklistItem.partner">
              <td class="details-table__col details-table__col_label">{{ $t('common.landlord') }}</td>
              <td class="details-table__col">
                <router-link :to="{ name: 'landlord', params: { id: blacklistItem.partner.landlord.id }, query: { keyword: blacklistItem.partner.landlord.name } }" class="link link--blue">
                    {{ blacklistItem.partner.landlord.name }}
                </router-link>
              </td>
            </tr>
            <tr class="details-table__row" v-if="isLandlord() && blacklistItem.partner">
              <td class="details-table__col details-table__col_label">{{ $t('common.tenant') }}</td>
              <td class="details-table__col">
                <router-link :to="{ name: 'tenant', params: { id: blacklistItem.partner.id }, query: { keyword: blacklistItem.partner.name } }" class="link link--blue">
                    {{ blacklistItem.partner.name }}
                </router-link>
              </td>
            </tr>
            <tr class="details-table__row" v-if="blacklistItem.createdBy.id">
              <td class="details-table__col details-table__col_label">{{ $t('common.created_by') }}</td>
              <td class="details-table__col">
                <router-link :to="{ name: 'tenant', params: { id: blacklistItem.createdBy.id }, query: { keyword: blacklistItem.createdBy.name } }" class="link link--blue">
                    {{ blacklistItem.createdBy.name }}
                </router-link>
              </td>
            </tr>
            <tr class="details-table__row" v-else>
              <td class="details-table__col details-table__col_label">{{ $t('common.created_by') }}</td>
              <td class="details-table__col">{{ blacklistItem.createdBy.name }}</td>
            </tr>
            <tr class="details-table__row">
              <td class="details-table__col details-table__col_label">{{ $t('common.created_at') }}</td>
              <td class="details-table__col">{{ blacklistItem.createdAt }}</td>
            </tr>
          </table>
      </div>
    </div>
    <ConfirmationModal v-if="showConfirmationModal" @cancel="closeBlacklistedItemDeletion" @confirmed="deleteBlacklistedItem">
      <h1 slot="header">{{ $t('common.deleting') }}: {{ blacklistItem.vehicleReg }} </h1>
      <p slot="body">{{ $t('permits.confirm_delete') }}</p>
    </ConfirmationModal>
    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ warningHeader }}</h1>
      <p slot="body">{{ warningBody }}</p>
    </WarningModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';

export default {
  components: {
    ConfirmationModal,
    WarningModal,
  },
  computed: mapGetters({
    blacklistItem: 'blacklist/blacklist/blacklistItem',
    blacklistError: 'blacklist/blacklist/error',
  }),
  watch: {
    $route: 'fetchBlacklistItem',
  },
  route: {
    canReuse: true,
  },
  created() {
    if (this.$route.params.id) {
      this.fetchBlacklistItem();
    }
  },
  methods: {
    isDeleted() {
      return this.blacklistItem.isDeleted;
    },
    fetchBlacklistItem() {
      if (this.$route.params.id && this.user.data) {
        this.$store.dispatch('blacklist/blacklist/fetch', { id: this.$route.params.id, user: this.user });
      }
    },
    deleteBlacklistedItem() {
      this.closeBlacklistedItemDeletion();
      this.$store.dispatch('blacklist/blacklist/delete', { id: this.$route.params.id, user: this.user }).then(() => {
        if (this.blacklistError) {
          this.warningHeader = this.$t('common.deleting');
          this.warningBody = this.$t('permits.delete_error');
          this.showWarningModal = true;
        } else {
          this.$store.commit(`landlord/blacklists/${mTypes.REMOVE_DATA}`, this.$route.params.id);
          this.$router.push({ name: 'blacklists' });
        }
      });
    },
    showDeletingConfirmation() {
      this.showConfirmationModal = true;
    },
    closeBlacklistedItemDeletion() {
      this.showConfirmationModal = false;
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    isCreator() {
      return this.user.data.selectedRole.id === this.blacklistItem.createdBy.id;
    },
  },
  data() {
    return {
      showConfirmationModal: false,
      showWarningModal: false,
      warningBody: null,
      warningHeader: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/blocks/details.scss';
.btn {
  min-width:100%;
}
</style>



// WEBPACK FOOTER //
// src/components/blacklist/BlacklistDetails.vue